import {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import InvestmentTransactionCard from './investment_transaction_card';
import InvestmentPriceGraph from './investment_price_graph';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';
import { reformatDateToDisplay } from '../../../objects/CommonUse/reformatDateToDisplay_function';
import { rollBackwardDate } from '../../game-views/objects/roll_backward_date_function';
import InvestmentGeneralInfoCard from './investment_general_info_card';


class InvestmentSellInfoCard extends Component {
    constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state = {open: false, 
            selected: false,
            errorFound: false,
            timeout: "",
            sellQuantity: "",
        };
        this.errorMsg = "";
        this.determineKeyDateInfo();
    }

    determineKeyDateInfo(){
        this.currentMonthNbr = 
            +this.moneyBuildInfo.totalNbrGameMonths - +this.moneyBuildInfo.gameData.gameNbrMonths;
        this.firstMonthDate = rollBackwardDate(this.moneyBuildInfo.gameData.currentGameDate, 12);
    }
        
    toggleDetailInfo(investShortName) {
        this.detailTransArr = [];
        this.investShortName = investShortName;
        for (let i=0; i<this.props.buyTransArr.length; i++){
            const transaction = this.props.buyTransArr[i];
            if (transaction.investShortName === investShortName){
                this.detailTransArr.push(transaction);
            }
        }
        this.buyDates = [];
        for (let i=0; i<this.detailTransArr.length; i++){
            const buyDate = reformatDateToDisplay(this.detailTransArr[i].transactionDate);
            this.buyDates.push(buyDate);
        }
        this.displayPriceGraph = true;
        const investType =  this.moneyBuildInfo.investmentMasterData.find(elem => 
            elem.investShortName === this.investShortName).investmentType;
        if (investType === "bond"){
            this.displayPriceGraph = false;
        }
        this.open = !this.open;
        this.setState({open: !this.state.open});
    }

    onSellQuantity(sellQuantity){
        this.setState({sellQuantity: sellQuantity});
        if(this.state.timeout) clearTimeout(this.state.timeout);
                this.state.timeout = setTimeout(() => {
                this.processSellEntry(sellQuantity);
        }, 500);
    }

    processSellEntry(sellQuantity){
        this.qtyError = false;
        this.errorMsg = "";
        this.editSellQuantity(sellQuantity);
        if (this.qtyError === false){
            const detailTranObj = 
                this.props.buyTransArr.find(elem => elem.investShortName + +elem.transNbr
                     === this.props.investInfo.investShortName + +this.props.investInfo.transNbr);
            const currentPrice = detailTranObj.currentPrice;
            this.sellAmount = (+currentPrice * sellQuantity).toFixed(2);
            let returnObj = {shortName: this.props.investInfo.investShortName, quantity: sellQuantity, 
                totalAmount: this.sellAmount, currentPrice: +currentPrice, transNbr: detailTranObj.transNbr,
                tranType: "sell", initialBuyQty: detailTranObj.quantity}
            this.props.onSellInvestment(returnObj);
              
        }
        this.setState({errorFound: this.qtyError});
    }

    editSellQuantity(sellQuantity){
         if (isNaN(+sellQuantity)){
            this.errorMsg = "Quantity Must be Numeric";
            this.sellAmount = undefined;
            this.qtyError = true;
         }else{
            if (sellQuantity > this.props.investInfo.quantity){
                this.errorMsg = "Quantity sold cannot be greater than qty owned."
                this.qtyError = true;
            }
         }
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.investType !== this.props.investType) {
            this.setState({ sellQuantity: "" });
            this.investType = this.props.investType;
            this.sellAmount = "";
            // You can also reset purchasePrice or other instance variables here
        }
    }

    render() {
        if (this.investType !== this.props.investType){
            this.open = false;
            this.investType = this.props.investType;
        }
        this.investType = this.props.investType;
        const defaultImgSrc="./assets/Investments/" + this.props.investInfo.imageUrl;
        if (this.open === true){
            this.stockDetailTrans = this.detailTransArr.map((transaction, index) =>
                <InvestmentTransactionCard key={index} transInfo={transaction} 
                    summaryPage={false}
                />
            );
        }
      
    return <>
   
        <div className="card mx-3 drop-shadow">
        </div>
           <div className="card-header text-left">
                <span className="container m-0 p-0">
                    <span className="container m-0 p-0">
                    <span className="mx-2 row w-100 my-0">
                        <div className="col-sm-1">
                           <img src={defaultImgSrc} className="medium_sign_thumbnail_img" alt="logo"/>
                       </div>    
                        <div className="col-sm-9">
                            <h5 className="text-center">
                                    {this.props.investInfo.investmentName}
                            </h5>
                        </div>
                        <div className="text-right col-sm-1"
                            onClick={() => this.toggleDetailInfo(this.props.investInfo.investShortName)}
                            >
                            {this.open ?
                                <FontAwesomeIcon icon={faCaretDown} className="career_card_caret" />
                                :
                                <FontAwesomeIcon icon={faCaretRight} className="career_card_caret" />
                            }
                        </div>
                    </span>
                    <div className="ml-2">
                            <InvestmentGeneralInfoCard
                                buySell={"sell"}
                                investInfo={this.props.investInfo}
                                investType={this.props.investType}
                                startGameDate={this.moneyBuildInfo.gameData.startGameDate}
                            />
                    </div>
                    {this.props.displayType === "sell"  ?
                        <div className="text-right">
                            <label className="font-weight-bold" htmlFor="quantity">
                                Quantity To Sell:&nbsp;&nbsp;</label>
                                <input type="text" className="col-sm-2" id="quantity" name="quantity"
                                    value={this.state.sellQuantity}
                                    onChange={(e) => this.onSellQuantity(e.target.value)}
                                />
                                <div className="text-danger">{this.errorMsg}</div>
                        </div>
                    :
                        null
                    }
                    {this.sellAmount  ?
                        <div className="total-line-container">
                            <span className="left-text-placement font-weight-bold ml-2">
                                Scroll to the Top to Review or Confirm Sales
                            </span>
                            <span className="right-text-placement">
                                <span className="font-weight-bold">&nbsp;Total Sale Amount:&nbsp;&nbsp;</span>
                                <span className="ml-4">{doubleToStringMonthly(this.sellAmount)}</span>
                            </span>
                        </div>
                    :
                        null
                    }
                </span>
                {this.open   ?
                    <span>
                        <div className="solid-line"></div>
                        <h5 className="text-center mt-4">Detail 'Buy' Transactions for This Investment</h5>
                        <table className="table">
                            <tbody>
                            <tr>
                                <th className="text-center">Tran Date</th>
                                <th className="text-center">Quantity</th>
                                <th className="text-center">Initial Unit Cost</th>
                                <th className="text-center">Total Initial Cost</th>
                                <th className="text-center">Current Unit Cost</th>
                                <th className="text-center">Total Current Cost</th>
                                <th className="text-center">Gain or Loss Amt</th>
                            </tr>
                                {this.stockDetailTrans}
                            </tbody>
                        </table>
                        <div>
                            {this.displayPriceGraph ?
                                <InvestmentPriceGraph
                                    investmentName = {this.props.investInfo.investmentName}
                                    monthNbr={this.currentMonthNbr}
                                    firstMonthDate={this.firstMonthDate}
                                    investType={this.props.investType}
                                    buyDates={this.buyDates}
                                    investShortName={this.investShortName}
                                    processError = {(errorObj) => this.props.processError(errorObj)}
                                />
                            :
                                <div className="mt-2">
                                    The price graph is not shown for bonds because there is not much 
                                    fluctuation in price so the graph is mostly a straight Line
                                    which is not very helpful.
                                </div>
                            }    
                        </div>
                    </span>
                :
                    null
                }
                </span>
        </div>
           
    </>
    }
    componentWillUnmount(){
        this.setState({open: false});
    }

}

export default InvestmentSellInfoCard;